module.exports = __webpack_public_path__ + "img/cart.e173359d.svg";